import {
  FieldRichText,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';

import { SanitizeHTML } from 'app/utils/htmlSanitizer';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import type { FlowManagerEditModalComponentT } from 'fable/flowEditor';

import { WidgetPreview } from '../../../conversation/components/widgetPreview';
import {
  FlowChatNodeChatMessagePayloadT,
  FlowChatNodeChatMessageT,
} from '../nodeTypes';

type PropsT = FlowManagerEditModalComponentT<FlowChatNodeChatMessageT>;

type StateT = {
  payload: FlowChatNodeChatMessagePayloadT;
  hasChanges: boolean;
};

export default class ChatMessageModal extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    let payload: FlowChatNodeChatMessagePayloadT;
    if (this.props.node.payload !== null) {
      payload = this.props.node.payload;
    } else {
      payload = {
        text: '',
        nextNodeId: uuid(),
      };
    }

    this.state = {
      payload,
      hasChanges: false,
    };
  }

  @boundMethod
  prepareNode(): FlowChatNodeChatMessageT {
    return {
      ...this.props.node,
      nodeType: FlowNodeTypes.CHAT_MESSAGE,
      text: 'Message',
      icon: 'i-channels',
      isRemovable: true,
      isEditable: true,
      isAction: false,
      badges: [],
      overlay: [],
      payload: this.state.payload,
    };
  }

  @boundMethod
  handleMessageChange(newText: undefined | string): void {
    this.setState({
      payload: { ...this.state.payload, text: newText ?? '' },
      hasChanges: true,
    });
  }

  @boundMethod
  handleCancel(): void {
    this.props.triggerClose();
  }

  @boundMethod
  handleSave(): void {
    const { replaceNode, triggerClose } = this.props;
    replaceNode(this.prepareNode());
    triggerClose();
    this.setState({
      hasChanges: false,
    });
  }

  render() {
    const {
      payload: { text },
    } = this.state;
    const { node, nodeLabel } = this.props;
    const { payload } = node;
    const payloadText = payload?.text;

    const isChanged = text !== payloadText;

    return (
      <div className="conversational-modal modal-chatflow-holder">
        <ModalHead title={nodeLabel} onClose={this.handleCancel}>
          The &quot;Message&quot; action allows you to send auto replies to
          customers following any action.
        </ModalHead>
        <ModalBody>
          <div className="conversational-modal__columns">
            <div className="conversational-modal__column">
              <WidgetPreview
                message={text}
                className="conversational-modal__preview"
              />
            </div>
            <div className="conversational-modal__column">
              <FieldRichText
                allowFormatting={true}
                sanitize={SanitizeHTML.sanitizerForProfile('widgetchat')}
                className="conversational-modal__editor"
                label="Your message"
                input={{
                  name: 'message',
                  onChange: this.handleMessageChange,
                  value: text,
                }}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFoot
          confirmOnClick={this.handleSave}
          confirmName={getConfirmButtonVerb(node)}
          confirmProps={{ disabled: !isChanged }}
          cancelOnClick={this.handleCancel}
        />
      </div>
    );
  }
}
